/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type WorkatoIntegration = "HiBob" | "%future added value";
export type StartRecipesInput = {
    integration?: WorkatoIntegration | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type startRecipesMutationVariables = {
    input: StartRecipesInput;
};
export type startRecipesMutationResponse = {
    readonly startRecipes: {
        readonly outcome: string | null;
    } | null;
};
export type startRecipesMutation = {
    readonly response: startRecipesMutationResponse;
    readonly variables: startRecipesMutationVariables;
};



/*
mutation startRecipesMutation(
  $input: StartRecipesInput!
) {
  startRecipes(input: $input) {
    outcome
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "StartRecipesInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "StartRecipesPayload",
    "kind": "LinkedField",
    "name": "startRecipes",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "outcome",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "startRecipesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "startRecipesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "startRecipesMutation",
    "operationKind": "mutation",
    "text": "mutation startRecipesMutation(\n  $input: StartRecipesInput!\n) {\n  startRecipes(input: $input) {\n    outcome\n  }\n}\n"
  }
};
})();
(node as any).hash = 'cc07ad06f753abc5879ba3fc55608528';
export default node;
